export const STAFF_EMAIL = 'staffEmail';
export const STAFF_ID = 'staffId';
export const IMPERSONATE_LAST_PAGE = 'impersonateLastPage';
export const STAFF_TOKEN_WHILE_IMPERSONATE = 'staffTokenWhileImpersonate';
/**
 * Loader route the app sits on while an impersonation starts or ends. The session identity is
 * half swapped while it is shown, so analytics must not treat it as a page.
 */
export const IMPERSONATION_TRANSITION_PATH = '/deeplink/impersonation';
export const SOCIAL_LOGIN_PROVIDERS = {
    magic_link: 'magic_link',
    google: 'google',
} as const;

/**
 * Error codes returned by the magic link authentication API.
 * Used for type-safe error handling in magic link flows.
 */
export enum MagicLinkErrorCode {
    /** Token was not found in the database (deleted or never existed) */
    NOT_FOUND = 'not_found',
    /** Token has already been used to log in */
    CONSUMED = 'consumed',
    /** Token has expired but can be renewed */
    EXPIRED = 'expired',
    /** Token is still valid (renewal attempted but not needed) */
    STILL_VALID = 'still_valid',
}
